import { BackendTemplate } from "../../model/model/gencode/BackendTemplate";
import { FileCodeBackend } from "../../model/model/gencode/FileCodeBackend";
import { BaseController } from "../fake/BaseController";

export class FileCodeBackendController extends BaseController<FileCodeBackend> {}
